module.exports = __webpack_public_path__ + "static/media/15.Chicken Dressing Machine.a023215e.jpg";